import { FieldDefinitionDto } from '@/components/table/types/TableDefinitionDto.ts';
import { FieldImportance } from '@/components/table/types/FieldImportance.ts';
import { isVisibleColumn } from '@/components/table/preferences/columnPreferences.ts';

/**
 * Tabela bez żadnego PRIMARY z backendu i tak musi mieć tytuł karty, więc
 * pierwsze widoczne pole robi za primary, a dwa kolejne za secondary.
 */
export function resolveFieldImportance(
  fields: FieldDefinitionDto[],
): Map<string, FieldImportance> {
  const visible = fields.filter(isVisibleColumn);
  const hasPrimary = visible.some(
    (field) => field.importance === FieldImportance.PRIMARY,
  );

  return new Map(
    visible.map((field, index) => {
      if (hasPrimary) return [field.fieldId, field.importance];
      if (index === 0) return [field.fieldId, FieldImportance.PRIMARY];
      if (index <= 2) return [field.fieldId, FieldImportance.SECONDARY];
      return [field.fieldId, FieldImportance.EXTRA];
    }),
  );
}

export const isPrimaryField = (
  field: FieldDefinitionDto,
  resolved: Map<string, FieldImportance>,
): boolean => resolved.get(field.fieldId) === FieldImportance.PRIMARY;
